import React from "react";
import {useStores} from "../../../../../../stores";
import {
    CategorizationViewOnlyComponent
} from "../../../../../../components/categorization/CategorizationViewOnlyComponent.tsx";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {categoryToLabels} from "../../../../../../services/classes/Category.ts";

export const StaticCategoryCell: React.FC<DeserializedGridCellParams<PartGridRowModel>> = ({row, colDef}) => {
    const {p, bagStore} = useStores();
    const field = colDef.field; // previous_cat or input_cat
    if (!row || !row[field]) return <></>;
    const taxonomySize = bagStore.taxonomy_size;
    const labels = categoryToLabels(row[field], taxonomySize, !!p.p.allowIncompleteTaxonomy, !!p.p.hideRepeatingLabels);
    return <CategorizationViewOnlyComponent category={labels}/>
}
